module.exports = __webpack_public_path__ + "img/slide4-992.53015462.png";